/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/** @module core/modules/reg-exp-utils/normalize */
import { isPrimitive } from '../../object-utils/internals/is-primitive.js';
import { stringifyPrimitive } from '../../stringify-primitive.js';
import { escape } from './ecape.js';
/** @typedef {(string|RegExp|Array<(string|RegExp)>)} normalizeRawExpType */

/**
 * @description Converts valid inputs into an array of RegExps.
 * @param {normalizeRawExpType} rawExp - Input to be converted.
 * @returns {Array<RegExp>} Conversion result.
 */

function normalize(rawExp) {
  var _this = this;

  if (_Array$isArray(rawExp)) {
    var _context;

    return _mapInstanceProperty(rawExp).call(rawExp, _bindInstanceProperty(_context = function _context(elem) {
      _newArrowCheck(this, _this);

      return normalize(elem)[0];
    }).call(_context, this));
  }

  if (rawExp instanceof RegExp) {
    return [rawExp];
  } else if (typeof rawExp === 'string') {
    return [new RegExp(escape(rawExp))];
  } else if (isPrimitive(rawExp) && rawExp !== null) {
    return [new RegExp(escape(stringifyPrimitive(rawExp)))];
  } else {
    return [];
  }
}

export { normalize };